import { render, staticRenderFns } from "./CurrentPurchaseInvoice.vue?vue&type=template&id=c898331a&scoped=true&"
import script from "./CurrentPurchaseInvoice.vue?vue&type=script&lang=js&"
export * from "./CurrentPurchaseInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c898331a",
  null
  
)

export default component.exports